import {Box, Heading, IconButton, Image} from '@chakra-ui/react';
import React, {useEffect, useState} from 'react';
import {MdOutlineArrowBack, MdOutlineArrowForward} from 'react-icons/md';
import {sendAudioClick, sendAudioHover} from '../../vuplex';
import Carousel from './Carousel';
import {useDispatch, useSelector} from 'react-redux';
import {folderOpen, foldersFeaturedRequest} from '../../reducers/pinsReducer';
import _ from 'lodash';

const FolderFeaturedCard = ({folder}) => {
  const {featuredImageUrl, label} = folder;
  const [isHovering, setIsHovering] = useState(false);
  const dispatch = useDispatch();


  return (
    <Box
      bgGradient={isHovering ? undefined : 'linear(180deg, #0000, #000c)'}
      borderRadius="2xl"
      h="8em"
      w="14em"
      marginX={2}
      overflow="hidden"
      position="relative"
      onClick={(evt) => {
        sendAudioClick(evt);
        dispatch(folderOpen(folder));
      }}
      onPointerEnter={(evt) => {
        setIsHovering(true);
        sendAudioHover(evt);
      }}
      onPointerLeave={() => {
        setTimeout(() => setIsHovering(false), 100);
      }}
    >
      <Image
        fit="cover"
        h="full"
        position="relative"
        src={featuredImageUrl}
        zIndex={-1}
      />

      <Heading
        bottom="1em"
        color="white"
        fontWeight="regular"
        paddingX={3}
        paddingY={0}
        position="absolute"
        size="md"
        textAlign="center"
        w="full"
      >
        {label}
      </Heading>

    </Box>
  );
}


const PinsFeatured = ({firstPhotoOverride, photos}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(foldersFeaturedRequest({}));
  }, []);

  const foldersFeatured = useSelector(s => s.pins.foldersListFeatured.response) || [];
  const h='11.5em';

  return foldersFeatured.length ? (
    <Box
      borderRadius="2xl"
      bgGradient={'linear(0deg, #404F5A, #6D7D89)'}

      // h={h}
      // w="full"
      // overflow="hidden"
      position="relative"
      p={2}
      m={2}
    >
      <Heading color="white" size="md" marginLeft="2.4em" marginBottom={2} fontWeight="regular">
        Featured Places
      </Heading>
      <Box
        // borderRadius="2xl"
        // overflow="hidden"
        // p={0}
        sx={{
          '.carousel .control-dots': {
            bottom: '1em',
            margin: 0,
          },
          '.carousel-slider': {
            height: h,
          },
          '.slider-wrapper': {
            height: h,
          },
        }}
        w="full"
      >
        <Carousel
          autoPlay
          renderArrowNext={(onClick, hasNext) =>
            hasNext && (
              <IconButton
                bottom={1}
                icon={<MdOutlineArrowForward color="black24" size="1.5em"/>}
                isRound
                onClick={(evt) => {
                  sendAudioClick(evt);
                  onClick(evt);
                }}
                position="absolute"
                right={2}
                variant="buttonMinor"
                zIndex={2}
              />
            )}
          renderArrowPrev={(onClick, hasPrev) =>
            hasPrev && (
              <IconButton
                bottom={1}
                icon={<MdOutlineArrowBack color="black24" size="1.5em"/>}
                isRound
                left={2}
                onClick={(evt) => {
                  sendAudioClick(evt);
                  onClick(evt);
                }}
                position="absolute"
                variant="buttonMinor"
                zIndex={2}
              />
            )}
        >
          {_.chunk(foldersFeatured, 3).map((folders, idx) => (
            <Box key={idx} w="full" display="flex" justifyContent="center" alignItems="center">
              {folders.map(folder => (
                <FolderFeaturedCard folder={folder} key={folder._id} />
              ))}
            </Box>
          ))}
        </Carousel>
      </Box>
    </Box>
  ) : null;
};

export default PinsFeatured;
